// 监听购物车接口事件，自定义全局的一个事件，方便后续监听
// 拦截 form 原生提交、fetch、XMLHttpRequest 三种加购方式
// 防抖 400ms，触发自定义事件 myCusCart:Update
function myCustomCartListenEvent() {
    const CART_URL_PATTERN = /\/cart\/(add|change|update|clear)\.js/;
    let _debounceTimer = null;

    // add 请求发出时立即派发，无需等待响应
    function dispatchCartAddStart() {
        document.dispatchEvent(new CustomEvent('myCusCart:AddStart'));
    }

    function dispatchCartUpdate(type) {
        clearTimeout(_debounceTimer);
        // add 类型跳过防抖，响应回来后立即触发；其他类型保留防抖
        const delay = type === 'add' ? 0 : 200;
        _debounceTimer = setTimeout(() => {
            document.dispatchEvent(new CustomEvent('myCusCart:Update', { detail: { type: type || 'unknown' } }));
        }, delay);
    }

    // 1. 拦截 form 原生提交（Shopify liquid 中 action="/cart/add|change|update|clear" 的表单）
    // 阻止默认跳转，改用 fetch 提交表单数据
    document.addEventListener('submit', function(e) {
        const form = e.target;
        if (!form || !form.action) return;
        try {
            const url = new URL(form.action, window.location.origin);
            if (CART_URL_PATTERN.test(url.pathname + '.js') || /\/cart\/(add|change|update|clear)/.test(url.pathname)) {
                e.preventDefault();
                e.stopPropagation();
                // add 请求发出，立即通知
                if (/\/cart\/add/.test(url.pathname)) {
                    dispatchCartAddStart();
                }
                const formData = new FormData(form);
                const fetchUrl = url.pathname.endsWith('.js') ? url.pathname : url.pathname + '.js';
                fetch(fetchUrl, {
                    method: form.method && form.method.toUpperCase() === 'GET' ? 'GET' : 'POST',
                    headers: { 'Accept': 'application/json' },
                    body: form.method && form.method.toUpperCase() === 'GET' ? undefined : formData
                }).then(function(res) {
                    return res.json();
                }).then(function() {
                    const _actionMatch = fetchUrl.match(/\/cart\/(add|change|update|clear)/);
                    dispatchCartUpdate(_actionMatch ? _actionMatch[1] : 'unknown');
                }).catch(function(err) {
                    console.log('myCustomCartListenEvent form submit error:', err);
                });
            }
        } catch (_) {}
    }, true);

    // 2. 拦截 fetch 请求
    const _originalFetch = window.fetch;
    window.fetch = function(input, init) {
        const url = (typeof input === 'string') ? input : (input?.url || '');
        const result = _originalFetch.apply(this, arguments);
        if (CART_URL_PATTERN.test(url)) {
            const _fetchActionMatch = url.match(/\/cart\/(add|change|update|clear)/);
            const _fetchActionType = _fetchActionMatch ? _fetchActionMatch[1] : 'unknown';
            // add 请求已发出，立即通知（无需等响应）
            if (_fetchActionType === 'add') {
                dispatchCartAddStart();
            }
            result.then(() => {
                dispatchCartUpdate(_fetchActionType);
            }).catch(() => {});
        }
        return result;
    };

    // 3. 拦截 XMLHttpRequest
    const _originalXHROpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
        this._myCusCartUrl = url || '';
        const _xhrActionMatch = (url || '').match(/\/cart\/(add|change|update|clear)/);
        this._myCusCartActionType = _xhrActionMatch ? _xhrActionMatch[1] : 'unknown';
        return _originalXHROpen.apply(this, arguments);
    };

    const _originalXHRSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function() {
        if (CART_URL_PATTERN.test(this._myCusCartUrl || '')) {
            const _xhrType = this._myCusCartActionType || 'unknown';
            // add 请求发出，立即通知
            if (_xhrType === 'add') {
                dispatchCartAddStart();
            }
            this.addEventListener('load', function() {
                dispatchCartUpdate(_xhrType);
            });
        }
        return _originalXHRSend.apply(this, arguments);
    };
}

document.addEventListener("DOMContentLoaded", function() {
    myCustomCartListenEvent();
    setTimeout(()=>{
        let appDom = document.getElementById('myCustomCartBundleId');
        appDom.style.visibility = 'visible';
        let comparelistWrap = $('#myCustomCartBundleId');
        comparelistWrap.addClass('isshow');
    },100)
});

const { createApp, onMounted, onUnmounted, ref, computed, watch } = Vue;

// ===== 产品限购功能 2026年 =====
// 限购产品配置：{ 产品ID(product_id): 每单购买上限 }
// 按 product_id 匹配（即同一产品所有变体合计），与详情页保持一致。
// ⚠️ 新增/调整限购产品时，需同步维护 sections/template-product-default.liquid 中的同名配置 MY_PRODUCT_PURCHASE_LIMIT_MAP
var MY_PRODUCT_PURCHASE_LIMIT_MAP = {
    8406247932071: 1  // switchbot-tag-for-new-subscribers
};
function myGetProductPurchaseLimit(productId) {
    return MY_PRODUCT_PURCHASE_LIMIT_MAP[productId];
}

createApp({
    compilerOptions: {
        delimiters: ['[[', ']]'],
    },
    setup() {
        // ------ 变量区Start

        // 当前的金钱的标识 US$
        let currentMoneySymbol = ref('US$')
        const MAX_RECOM_Prod_COUNT = 16;

        // 接口获取的 cart整个对象
        let cartJsonData = ref({});
        // 加入购物车的商品列表
        let cartItems = computed(() => {
            return cartJsonData.value.items || [];
        })

        // 获取打折满减等最后的 总金额
        let cartTotalPrice = computed(() => {
            return cartJsonData.value.total_price || 0;
        })
        // 获取 打折满减等的所有金额
        // let cartAllDCPrice = computed(() => {
        //     return cartJsonData.value.total_price_all || 0;
        // })

        let myCartOtherConfig = ref({})
        let myCartProdRecommdConfig = ref({})
        let myCartProdDCConfig = ref({})
        let installmentImgList = ref([]) // 分期图标的列表
        // 是否展示 顶部免运费的tips
        let cartTopTipsObj = ref({})

        // 后续使用， 用户输入的折扣的列表
        let inputDiscounts = ref([])

        // 从接口获取的推荐产品列表
        let prodRecommendItems = ref([])
        let prodRecommendItemTransformWidth = ref(0)
        // 从后台获取的配置的产品的列表
        let recomProdAddCartShow = ref(false)
        let recomProdAddCartItem = ref({
            choosedVariantObj: {},
            prodObj:{},
        })

        let isShowCart = ref(false)
        let isShowLoading = ref(false)

        // 自定义弹窗，是否显示 灵活分期支付的弹窗
        let myCustomFQShow = ref(false)
        //  addNote 展开
        // let myCustomCartAddNoteShow = ref(false)
        // let myCustomCartAddNote = ref('')
        // ------ 变量区End

        onMounted(async () => {
            document.addEventListener('click', handleDocClickCloseVariantFn);
            initCartShowFn()
            getCartConfigFn()
            await getCartJsonData()
            // await startRecommendProdFn()
            getCartDCConfigFn()
            // 存一下购物车里的初始化的可用折扣
            // getCartInitDCFn()

            // 最后设置下购物车的 attributes 属性
            setCartAttributesFn()
        })
        onUnmounted(() => {
            document.removeEventListener('click', handleDocClickCloseVariantFn);
        })
        watch(() => cartJsonData.value.item_count, (newVal, oldVal) => {
            if (newVal !== oldVal) {
                // 购物车商品数量变化时，更新购物车的数字变化
                newVal = newVal > 99 ? '99+' : newVal;
                document.getElementById('myCustomCartClickStartIdNum').textContent = newVal;
            }
        })
        watch(() => cartJsonData.value.items?.length, async (newVal, oldVal) => {
            if (newVal !== oldVal) {
                // 购物车的里边的产品行变化时
                await startRecommendProdFn()
            }
        })
        watch(() => cartJsonData.value.discount_codes, (newVal, oldVal) => {
            if (newVal !== oldVal) {
                getCartInitDCFn();
            }
        }, { deep: true, immediate: true })
        // 每次打开购物车时强制重新拉取最新数据，
        // 兜底第三方插件（如满额送礼）绕过请求拦截、导致视图与真实购物车不同步的情况
        watch(isShowCart, (val) => {
            if (val) {
                getCartJsonData();
            }
        })

        // 函数区---Start
        const initCartShowFn = () => {
            // 点击购物车图标，显示购物车
             document.getElementById('myCustomCartClickStartId').addEventListener('click', () => {
                isShowCart.value = true;
            })
            // 点击购物车其他地方，隐藏购物车
            document.getElementsByClassName('my-custom-cart-mask')[0].addEventListener('click', () => {
                isShowCart.value = false;
                myCustomFQShowFn(false);
            })
            // 点击购物车关闭按钮，隐藏购物车
            document.getElementsByClassName('my-custom-cart-closeBtn')[0].addEventListener('click', () => {
                isShowCart.value = false;
                myCustomFQShowFn(false);
            })
            // 点击购物车继续购物按钮，继续购物
            // document.getElementsByClassName('my-custom-cart-empty-continueshop')[0].addEventListener('click', () => {
            //     isShowCart.value = false;
            // })
            // 点击外部的加购，然后打开购物车
            addCartFromExternal();
        }
        const getCartJsonData = async () => {
            try {
                const data = await fetch('/cart.js').then(r => r.json());
                cartJsonData.value = data;
                // 限购兜底：每次拉取购物车后，校正超过上限的限购产品
                await myEnforcePurchaseLimitsOnCart();
                // 广播购物车已更新，供详情页等其它组件复核限购剩余数
                try {
                    document.dispatchEvent(new CustomEvent('my:cart-updated', { detail: cartJsonData.value }));
                } catch (e) { }
            } catch (err) {
                console.log(err, 'err');
                return false;
            }
        }
        // 计算某购物车行在限购规则下允许的最大数量
        // 按产品合计：上限 - 同产品其它行的数量之和（单变体产品一般只有一行，即等于上限）
        const myGetLineMaxByLimit = (item) => {
            const limitN = myGetProductPurchaseLimit(item?.product_id);
            if (!limitN) return Infinity; // 非限购产品，不限制
            let otherQty = 0;
            (cartJsonData.value?.items || []).forEach(ci => {
                if (ci.product_id === item.product_id && ci.id !== item.id) {
                    otherQty += ci.quantity;
                }
            });
            return Math.max(0, limitN - otherQty);
        };
        // 购物车限购文案提示：返回某行所属产品的限购提示文案（无限购返回空字符串）
        const myGetPurchaseLimitTip = (item) => {
            const limitN = myGetProductPurchaseLimit(item?.product_id);
            if (!limitN) return '';
            let totalQty = 0;
            (cartJsonData.value?.items || []).forEach(ci => {
                if (ci.product_id === item.product_id) { totalQty += ci.quantity; }
            });
            if (totalQty >= limitN) {
                return 'This item is limited to ' + limitN + ' per order. You have reached the limit.';
            }
            return 'Limited to ' + limitN + ' per order.';
        };
        // 购物车限购兜底：若限购产品的合计数量超过上限，自动调接口纠正回上限
        const myEnforcePurchaseLimitsOnCart = async () => {
            const items = cartJsonData.value?.items || [];
            if (!items.length) return;
            // 按产品聚合限购产品
            const grouped = {};
            items.forEach(ci => {
                const limitN = myGetProductPurchaseLimit(ci.product_id);
                if (limitN) {
                    if (!grouped[ci.product_id]) {
                        grouped[ci.product_id] = { limitN: limitN, lines: [], total: 0 };
                    }
                    grouped[ci.product_id].lines.push(ci);
                    grouped[ci.product_id].total += ci.quantity;
                }
            });
            for (const pid in grouped) {
                const info = grouped[pid];
                if (info.total > info.limitN) {
                    // 超量：从前往后保留至上限，其余行削减/清零
                    let remaining = info.limitN;
                    for (const line of info.lines) {
                        const target = Math.max(0, Math.min(line.quantity, remaining));
                        remaining -= target;
                        if (target !== line.quantity) {
                            const resData = await myCustomCartUpdateFn({ id: line.id + '', quantity: target });
                            if (resData?.token) cartJsonData.value = resData;
                        }
                    }
                }
            }
        };
        // 延迟二次校对购物车数据：
        // 用于兜底第三方插件（如满额送礼）在我们处理完加购后才异步修改购物车，
        // 且其请求绕过了请求拦截器、不会派发 myCusCart:Update 的情况。
        let _cartReconcileTimers = [];
        const scheduleCartReconcile = () => {
            // 先清掉上一轮尚未执行的校对，避免重复堆叠
            _cartReconcileTimers.forEach(t => clearTimeout(t));
            _cartReconcileTimers = [1500, 3000].map(delay => setTimeout(() => {
                getCartJsonData();
            }, delay));
        };
        // 存一下购物车里的初始化的可用折扣
        const getCartInitDCFn = () =>{
            if (cartJsonData.value?.discount_codes?.length) {
                inputDiscounts.value = [];
                cartJsonData.value?.discount_codes.map(item=>{
                    if(item.code&&item.applicable){
                        inputDiscounts.value.push(item.code)
                    }
                })
            } else {
                inputDiscounts.value = [];
            }
        };
        // 产品推荐的逻辑
        const startRecommendProdFn = async () => {
            // 1.先获取配置的全部的产品推荐，和针对某个产品的产品推荐
            // 2.在购物车没有产品时，需要只展示配置的全部的产品推荐
            // 3.产品推荐不能重复，不能和已经加入的产品变体有相同的
            // 4.当有产品加购时需要调用接口获取产品推荐，并且要查看当前加购的产品是否有产品推荐并且展示
            // 5.产品推荐总数不超过10个

            let defaultConfigArr = [];   // 后台配置的全局推荐
            let cartProdConfigArr = [];  // 后台配置的针对某产品的推荐
            let apiRecomArr = [];        // Shopify API 返回的推荐

            // 1. 始终加载全局配置的产品推荐（购物车为空时也需要展示）
            if (myCartProdRecommdConfig.value?.defaultRecomList?.length) {
                defaultConfigArr = JSON.parse(JSON.stringify(myCartProdRecommdConfig.value.defaultRecomList));
            }

            // 2. 购物车有产品时，追加对应产品的配置推荐 + 调用 Shopify 推荐接口
            if (cartItems.value?.length) {
                // 2a. 检查购物车每个产品是否存在后台单独配置的推荐，有则追加
                const prodRecomObj = myCartProdRecommdConfig.value?.prodRecomObj || {};
                if (Object.keys(prodRecomObj).length) {
                    cartItems.value.forEach(cartItem => {
                        const recomList = prodRecomObj[cartItem.id]?.recomList;
                        if (recomList?.length) {
                            let list = JSON.parse(JSON.stringify(recomList));
                            cartProdConfigArr.push(...list);
                        }
                    });
                }

                // 2b. 为购物车中的第一个产品调用 Shopify 推荐接口，收集到足够数量为止
                if(cartItems.value[0]?.product_id){
                    const res = await getRecommendProdFromProdIdFn(cartItems.value[0].product_id);
                    apiRecomArr.push(...res);
                }
            }

            // 3. 合并所有来源，优先级：全局配置 > 产品专属配置 > API推荐
            const allArr = [...defaultConfigArr, ...cartProdConfigArr, ...apiRecomArr];
            // 4. 按产品 ID 去重（Set 无法对对象去重，需手动处理）
            const seenIds = new Set();
            const deduped = [];
            for (const item of allArr) {
                const pid = item.id;
                if (pid && !seenIds.has(pid)) {
                    seenIds.add(pid);
                    deduped.push(item);
                }
            }

            // 5. 过滤掉已在购物车中的产品（比较推荐产品的 id 与购物车条目的 product_id）
            const cartProductIds = new Set(cartItems.value.map(c => c.product_id));
            const filtered = deduped.filter(item => item.available && !cartProductIds.has(item.id));
            // 再过滤下产品名称特殊的 包含 Special Offer
            const finalFiltered = filtered.filter(item => !item.title.includes('Special Offer'));
            // 6. 限制总数不超过 10 个，归一化数据结构，并重置轮播偏移
            prodRecommendItems.value = finalFiltered.slice(0, MAX_RECOM_Prod_COUNT).map(normalizeRecomProdFn);
            prodRecommendItemTransformWidth.value = 0;

            // 7. 同步更新推荐产品的折扣配置
            getCartDCConfigFn();
        }
        // 根据产品ID 调用 Shopify 推荐接口
        const getRecommendProdFromProdIdFn = async (prodId) => {
            try {
                const res = await fetch('/recommendations/products.json?product_id=' + prodId + `&limit=${MAX_RECOM_Prod_COUNT*2}&intent=related`);
                const data = await res.json();
                return data?.products?.length ? data.products : [];
            } catch (error) {
                return [];
            }
        }
        // 归一化推荐产品数据结构，统一元字段配置产品和 Shopify API 返回产品的字段格式
        const normalizeRecomProdFn = (item) => {
            // 产品 featured_image：模板直接作为 <img :src> 使用，需为字符串 URL
            item.featured_image = item?.featured_image
            // url：确保存在且以 /products/ 开头
            if (!item.url && item.handle) {
                item.url = '/products/' + item.handle;
            }
            // price：取第一个变体价格作为兜底
            if (item.variants?.[0]?.price) {
                item.price = item.variants[0].price;
            }
            if (item.variants && item.variants.length > 0) {
                item.variants = item.variants.map(variant => {
                    // 变体 featured_image：模板直接作为 <img :src> 使用，需为字符串 URL
                    variant.featured_image = {};
                    variant.featured_image.src = variant?.featured_image?.src || item.featured_image;
                    return variant;
                });
            }
            return item;
        }
        const myCustomCartRecomProdChargeFn = (type) => {
            // 产品推荐 左右按钮的切换
            let length = prodRecommendItems.value?.length || 0
            if (type === 'prev'){
                prodRecommendItemTransformWidth.value = prodRecommendItemTransformWidth.value - 50 < 0 ? 0 : prodRecommendItemTransformWidth.value - 50
            } else if (type === 'next'){
                prodRecommendItemTransformWidth.value = prodRecommendItemTransformWidth.value + 50 > (length - 1) * 50 ? (length - 1) * 50 : prodRecommendItemTransformWidth.value + 50
            }
        }
        // 已经加购的产品的 数量增减
        const myCustomCartAddProdQuantityFn = async (item, type) =>{
            try {
                isShowLoading.value = true;
                // cartJsonData.value.items.find(cartItem => cartItem.id === item.id);
                let findCartItem = cartJsonData.value.items.find(cartItem => cartItem.id === item.id);
                if(findCartItem?.id){
                    // 需要调用 cart的接口 更新 数量
                    let nextQuantity = type === 'plus'
                        ? findCartItem.quantity + 1
                        : (findCartItem.quantity >= 1 ? findCartItem.quantity - 1 : 0)
                    // 限购：按上限钳制本行最大数量
                    const lineMax = myGetLineMaxByLimit(findCartItem);
                    if (nextQuantity > lineMax) {
                        nextQuantity = lineMax;
                    }
                    // 已达上限（点加号但数量没变化），无需请求，直接返回
                    if (nextQuantity === findCartItem.quantity) {
                        return;
                    }
                    let resData = await myCustomCartUpdateFn({
                        id: findCartItem.id+'',
                        quantity: nextQuantity
                    })
                    if(resData?.token){ // 说明添加成功
                        cartJsonData.value = resData;
                    } else {
                        // 说明更新失败
                    }
                }
            } catch (error) {
                console.log(error, 'error');
            } finally {
                isShowLoading.value = false;
            }
        }
        const myCustomCartQuantityInputOnlyNumberFn = (event) => {
            let value = (event?.target?.value || '').replace(/\D/g, '');
            if (value.length > 4) {
                value = value.slice(0, 4);
            }
            event.target.value = value;
        }
        const myCustomCartQuantityInputCommitFn = async (item, event) => {
            let value = (event?.target?.value || '').replace(/\D/g, '');
            if (!value) {
                event.target.value = String(item.quantity || 1);
                return;
            }

            let quantity = Number(value);
            if (Number.isNaN(quantity)) {
                event.target.value = String(item.quantity || 1);
                return;
            }

            quantity = Math.max(1, Math.min(9999, quantity));
            // 限购：按上限钳制本行最大数量（至少为1，真正的超量删行由兜底逻辑处理）
            const lineMax = myGetLineMaxByLimit(item);
            if (quantity > lineMax) {
                quantity = lineMax < 1 ? 1 : lineMax;
            }
            event.target.value = String(quantity);

            if (Number(item.quantity) === quantity) {
                return;
            }

            let findCartItem = cartJsonData.value.items.find(cartItem => cartItem.id === item.id);
            if (!findCartItem?.id) {
                return;
            }

            let resData = await myCustomCartUpdateFn({
                id: findCartItem.id + '',
                quantity
            });
            if (resData?.token) {
                cartJsonData.value = resData;
            }
        }
        const myCustomCartAddProdQuantiyDeleteFn = async (item) =>{
            try {
                isShowLoading.value = true;
                let findCartItem = cartJsonData.value.items.find(cartItem => cartItem.id === item.id);
                if(findCartItem?.id){
                    // 需要调用 cart的接口 更新 数量
                    let resData = await myCustomCartUpdateFn({
                        id: findCartItem.id+'',
                        quantity:  0
                    })
                    if(resData?.token){ // 说明添加成功
                        cartJsonData.value = resData;
                    } else {
                        // 说明更新失败
                    }
                }
            } catch (error) {
                console.log(error, 'error');
            } finally {
                isShowLoading.value = false;
            }
        }
        const myCustomCartUpdateFn = async (params)=>{
            isShowLoading.value = true;
            let res
            try{
                res = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(params)
                }).then(r => r.json())
            } catch(err){
                console.log(err, 'err');
                res = false;
            } finally {
                isShowLoading.value = false;
            }
            return res
        }

        const recomProdAddCartShowFn = (flag)=>{
            // console.log(flag, 'flagflagflag')
            recomProdAddCartShow.value = flag;
            if(!flag){
                recomProdAddCartItem.value = {
                    choosedVariantObj: {},
                    prodObj:{},
                }
            }
        }
        const myCustomCartRecomProdAddToCartStart = (prodItem) => {
            // 由于产品推荐的 有变体有产品需要处理下。
            // console.log(prodItem, 'prodItemprodItem')
            // 判断是否有多个变体
            if (prodItem?.variants?.length > 1) {
                recomProdAddCartItem.value.prodObj = prodItem;
                recomProdAddCartItem.value.choosedVariantObj = prodItem.variants[0];
                recomProdAddCartShowFn(true);
            } else if(prodItem?.variants && prodItem?.variants[0].id) {
                // 没有多个变体，直接加入购物车
                let obj = {
                    id: prodItem.variants[0].id,
                    quantity: 1
                }
                myCustomCartRecomProdAddToCart(obj)
            } else {
                // 当前是变体对象
                let obj = {
                    id: prodItem.id,
                    quantity: 1
                }
                myCustomCartRecomProdAddToCart(obj)
            }
        }
        // 将推荐的产品加入购物车
        const myCustomCartRecomProdAddToCart = (addItem) => {
            // fetch('/cart/add.js', {
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/json'
            //     },
            //     body: JSON.stringify(addItem)
            // }).then(r => r.json()
            // .then(data => {
            //     if (data?.id) {
            //         recomProdAddCartShowFn(false)
            //         getCartJsonData()
            //     }
            // })).catch((err) => {
            //     console.log(err, 'err');
            // });
            myCustomCartAddFn(addItem).then(data => {
                if (data?.id) {
                    recomProdAddCartShowFn(false)
                    getCartJsonData()
                }
            }).catch((err) => {
                console.log(err, 'err');
            });
        }
        const myCustomCartRecomProdAddCartVariantChange = (e) => {
            recomProdAddCartItem.value.choosedVariantObj = recomProdAddCartItem.value.prodObj.variants.find(v => v.id == e.target.value)
        }
        const myCustomCartRecomProdAddToCartConfirm = ()=>{
            if(recomProdAddCartItem.value.choosedVariantObj.id){
                let obj = {
                    id: recomProdAddCartItem.value.choosedVariantObj.id,
                    quantity: 1
                }
                myCustomCartRecomProdAddToCart(obj)
            } else {
                // 没有选择变体，提示用户选择变体
            }
        }
        const myCustomCartCheckoutStart = () => {
            window.location.href = '/checkout';
        }

        // 自定义弹窗，是否显示 灵活分期支付的弹窗
        const myCustomFQShowFn = (flag) => {
            myCustomFQShow.value = flag;
        }
        // addNote 展开
        // const myCustomCartAddNoteShowFn = () => {
        //     let flag = myCustomCartAddNoteShow.value
        //     myCustomCartAddNoteShow.value = !flag;
        // }

        // 获取购物车的配置
        const getCartConfigFn = () => {
            // console.log(window.myCustomCartConfigObj, 'window.myCustomCartConfigObj')
            myCartOtherConfig.value = window.myCustomCartConfigObj?.otherConfig || {};
            myCartProdRecommdConfig.value = window.myCustomCartConfigObj?.prodRecomConfig || {};
            installmentImgList.value = myCartOtherConfig.value?.installmentImgList || [];
            myCustomSetTopFreeLineStyleFn();
        }
        // 设置顶部进度条的样式
        const myCustomSetTopFreeLineStyleFn = () => {
            cartTopTipsObj.value = {
                maxMoney: 0,
                cartTopTipsShow: myCartOtherConfig.value?.freeFreightEnable || myCartOtherConfig.value?.freeDiscountEnable || myCartOtherConfig.value?.freeGiftEnable,
                freeShip: {
                    show: myCartOtherConfig.value?.freeFreightEnable,
                    achieveMoney: myCartOtherConfig.value?.freeFreightMoney || 0,
                    style: {},
                },
                freeDiscount: {
                    show: myCartOtherConfig.value?.freeDiscountEnable,
                    achieveMoney: myCartOtherConfig.value?.freeFreightAchieveMoney || 0,
                    reduceMoney: myCartOtherConfig.value?.freeFreightReduceMoney || 0,
                    style: {},
                },
                freeGift: {
                    show: myCartOtherConfig.value?.freeGiftEnable,
                    achieveMoney: myCartOtherConfig.value?.freeGiftMoney || 0,
                    style: {},
                },
            }
            // 计算这里边的最大金额配置
            let maxMoney = 0;
            if(myCartOtherConfig.value?.freeFreightEnable){
                maxMoney = Math.max(maxMoney, cartTopTipsObj.value?.freeShip?.achieveMoney || 0)
            } 
            if (myCartOtherConfig.value?.freeDiscountEnable){
                maxMoney = Math.max(maxMoney, cartTopTipsObj.value?.freeDiscount?.achieveMoney || 0)
            }
            if (myCartOtherConfig.value?.freeGiftEnable){
                maxMoney = Math.max(maxMoney, cartTopTipsObj.value?.freeGift?.achieveMoney || 0)
            }
            cartTopTipsObj.value.maxMoney = maxMoney;
            // 计算每个进度条点的位置
            cartTopTipsObj.value.freeShip.style = cartTopTipsObj.value?.freeShip.show ? { left: `${(100 * cartTopTipsObj.value?.freeShip.achieveMoney / maxMoney).toFixed(2)}%` } : {}
            cartTopTipsObj.value.freeDiscount.style = cartTopTipsObj.value?.freeDiscount.show ? { left: `${(100 * cartTopTipsObj.value?.freeDiscount.achieveMoney / maxMoney).toFixed(2)}%` } : {}
            cartTopTipsObj.value.freeGift.style = cartTopTipsObj.value?.freeGift.show ? { left: `${(100 * cartTopTipsObj.value?.freeGift.achieveMoney / maxMoney).toFixed(2)}%` } : {}
        }
        // 计算距离免运费还差多少钱的提示文案
        const computedFreeTipsDesc = computed(() => {
            const config = cartTopTipsObj.value || {};
            const subtotal = Number((cartJsonData.value?.items_subtotal_price || 0) / 100);
            const candidates = [];

            if (config?.freeShip?.show) {
                const freightThreshold = Number(config.freeShip?.achieveMoney || 0);
                if (freightThreshold > 0) {
                    const diff = freightThreshold - subtotal;
                    if (diff > 0) {
                        candidates.push({
                            diff,
                            desc: `Only ${customMoneyFormatFn(diff*100)} left to get free shipping`
                        });
                    }
                }
            }

            if (config?.freeDiscount?.show) {
                const discountThreshold = Number(config.freeDiscount?.achieveMoney || 0);
                const discountReduceMoney = Number(config.freeDiscount?.reduceMoney || 0);
                if (discountThreshold > 0) {
                    const diff = discountThreshold - subtotal;
                    if (diff > 0) {
                        const rewardText = discountReduceMoney > 0
                            ? `${customMoneyFormatFn(discountReduceMoney*100)} coupon`
                            : 'coupon';
                        candidates.push({
                            diff,
                            desc: `Only ${customMoneyFormatFn(diff*100)} left to get ${rewardText}`
                        });
                    }
                }
            }

            if (config?.freeGift?.show) {
                const giftThreshold = Number(config.freeGift?.achieveMoney || 0);
                if (giftThreshold > 0) {
                    const diff = giftThreshold - subtotal;
                    if (diff > 0) {
                        candidates.push({
                            diff,
                            desc: `Only ${customMoneyFormatFn(diff*100)} left to get a free gift`
                        });
                    }
                }
            }

            if (candidates.length > 0) {
                candidates.sort((a, b) => a.diff - b.diff);
                return candidates[0].desc;
            }

            if (config?.freeShip?.show || config?.freeDiscount?.show || config?.freeGift?.show) {
                return 'Congrats! You have unlocked all current rewards.';
            }
            return '';
        })
        // 计算顶部免运费进度条的样式
        const myCustomFreeLineSolidComStyle = computed(()=>{
            let styleObj = {}
            if (cartTopTipsObj.value?.maxMoney > 0&&cartTopTipsObj.value?.cartTopTipsShow){
                let per = ((cartJsonData.value?.items_subtotal_price || 0)/100) / cartTopTipsObj.value.maxMoney > 1 ? 1 : ((cartJsonData.value?.items_subtotal_price || 0)/100) / cartTopTipsObj.value.maxMoney
                let widthPercent = (100* per).toFixed(2)
                styleObj = {
                    width: widthPercent+'%'
                }
                // console.log(widthPercent, 'widthPercent')
            }
            return styleObj
        })
        // 计算当前金额有没有获得免费礼物，去隐藏免费礼物的展示
        const myCustomFreeGiftIsGet = computed(()=>{
            if (cartTopTipsObj.value?.freeGift?.achieveMoney > 0) {
                const diff = cartTopTipsObj.value.freeGift.achieveMoney - (cartJsonData.value?.items_subtotal_price || 0) / 100;
                return diff <= 0;
            }
            return false;
        });

        // 监听函数 在购物车内直接修改变体
        const closeAllVariantSelectWrapsFn = () => {
            document.querySelectorAll('.my-custom-cart-addProd-item-info-variant-selectWrap').forEach((el) => {
                el.innerHTML = '';
            });
        }
        const handleDocClickCloseVariantFn = (event) => {
            const target = event?.target;
            if (!(target instanceof Element)) {
                return;
            }
            if (!target.closest('.my-custom-cart-addProd-item-info-variant')) {
                closeAllVariantSelectWrapsFn();
            }
        }
        const myCustomCartChangeVarinatStatrFn = async (cartItem, event) => {
            isShowLoading.value = true;
            try {
                const hostEl = event?.currentTarget?.closest('.my-custom-cart-addProd-item-info') || event?.currentTarget?.parentElement;
                if (!hostEl || !cartItem?.product_id) return;

                const existingPicker = hostEl.querySelector('.my-custom-cart-addProd-item-info-variant-selectWrap');
                if (!existingPicker) return;

                const hasOpened = existingPicker.innerHTML.trim().length > 0;
                closeAllVariantSelectWrapsFn();
                if (hasOpened) return;

                const handle = myCustomCartGetProductHandleFn(cartItem);
                if (!handle) return;

                const productData = await fetch(`/products/${handle}.js`).then(r => r.json());
                if (!productData?.variants?.length) return;
                if (productData.variants.length === 1) return;
                // console.log(productData, 'productData')

                const optionsHtml = productData?.variants.map(variant => {
                    const isSelected = Number(variant.id) === Number(cartItem?.id);
                    if(variant.available && !isSelected) {
                        return `<div data-variant-id="${variant.id}" class="my-custom-cart-addProd-item-info-variant-select-item">${variant.title}</div>`;
                    }
                }).join('');
                // console.log(optionsHtml, 'optionsHtml')

                existingPicker.innerHTML = optionsHtml;

                existingPicker.onclick = async (e) => {
                    const selectedVariantId = Number(e.target.dataset.variantId);
                    if (!selectedVariantId || selectedVariantId === cartItem.variant_id) {
                        return;
                    }
                    const removeRes = await myCustomCartUpdateFn({
                        id: (cartItem.id + ''),
                        quantity: 0
                    });
                    if (!removeRes?.token) {
                        return;
                    }
                    const addPayload = {
                        id: Number(selectedVariantId),
                        quantity: Number(cartItem.quantity || 1),
                        properties: cartItem.properties || {}
                    };

                    if (cartItem?.selling_plan_allocation?.selling_plan?.id) {
                        addPayload.selling_plan = cartItem.selling_plan_allocation.selling_plan.id;
                    }

                    const addRes = await myCustomCartAddFn(addPayload);
                    if (addRes?.id) {
                        await getCartJsonData();
                        existingPicker.innerHTML = '';
                    }
                };
            } catch (err) {
                console.log(err, 'err');
            } finally {
                isShowLoading.value = false;
            }
        }
        
        const myCustomCartGetProductHandleFn = (item) => {
            if (item?.handle) return item.handle;
            if (item?.url) {
                const match = item.url.match(/\/products\/([^/?#]+)/);
                if (match?.[1]) return match[1];
            }
            return '';
        }

        // 公共函数，调用add cart 接口
        const myCustomCartAddFn = async (params) => {
            isShowLoading.value = true;
            let res;
            try {
                res = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(params)
                }).then(r => r.json());
            } catch (err) {
                console.log(err, 'err');
                res = false;
            } finally {
                isShowLoading.value = false;
            }
            return res;
        }
        
        // 函数，监听外部的加购按钮
        const addCartFromExternal = () => {
            // add 请求发出时立即打开购物车 + 显示 loading，不等接口响应
            document.addEventListener('myCusCart:AddStart', () => {
                isShowCart.value = true;
                isShowLoading.value = true;
            });

            document.addEventListener('myCusCart:Update', async(event) => {
                const actionType = event?.detail?.type;
                // 隐藏其他插件的监听带来的遮罩层
                document.getElementById('mobile-menu-overlay').style.display = 'none';
                // 在获取新数据前，先快照当前数量（即本次事件发生前的旧数量）
                const countBeforeUpdate = cartJsonData.value?.item_count ?? 0;
                // 获取最新的购物车数据
                await getCartJsonData();
                // 兜底：第三方插件（满额送礼等）可能在本次加购之后才异步修改购物车，
                // 且其请求绕过了上方拦截器、不会再次派发 myCusCart:Update，
                // 这里做几次延迟二次校对，把插件后加的礼物补拉回来
                scheduleCartReconcile();
                if (actionType === 'add') {
                    // add 数据更新完毕，关闭 loading
                    isShowLoading.value = false;
                    return; // 购物车已由 AddStart 打开，无需后续处理
                }
                if (isShowCart.value) return; // 如果购物车已经打开了，就不需要再处理了

                const currentItemCount = cartJsonData.value?.item_count || 0;
                // 只有商品数量真正增加时（真正的加购操作），才打开购物车
                if (currentItemCount !== countBeforeUpdate) {
                    isShowCart.value = true;
                }
            });
        }

        // 获取购物车的 产品折扣配置
        const getCartDCConfigFn = () => {
            // console.log(window.myCustomCartSaveDCConfigObj, 'window.myCustomCartSaveDCConfigObj')
            myCartProdDCConfig.value = window.myCustomCartSaveDCConfigObj || {};
            // 遍历最终的产品推荐。遍历设置下产品的折扣。
            prodRecommendItems.value?.forEach(item => {
                let prodDCConfig = myCartProdDCConfig.value?.[item.product_id] || myCartProdDCConfig.value?.[item.id] || {};
                if(item?.variants?.length) {
                    item.dcConfig = prodDCConfig[item.variants[0].id] || {};
                } else {
                    item.dcConfig = prodDCConfig[item.id] || {};
                }
            })
        }

        // 最后设置下购物车的 attributes 属性
        const setCartAttributesFn = () => {
            if (window.navigator.userAgent.includes("SwitchBot")){
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        attributes: {
                            "__fromRegion": 'switchbotApp'
                        }
                    })
                });
            }
        }

        // 验证输入框的折扣的合理性
        const myCustomVerifyCodeCart = async () => {
            let discountCode = document.getElementById("myCustomCartDiscountCodeInputId").value;
            const message = document.getElementById("myCustomCartDiscountMessageId");
            discountCode = (discountCode+'').trim()
            if(!discountCode){
                message.textContent = "Please enter a discount code.";
                message.style.color = "red";
                return;
            }
            if (inputDiscounts.value&&inputDiscounts.value.length&&inputDiscounts.value.includes(discountCode)) {
                message.textContent = "Discount code already applied.";
                message.style.color = "red";
                return;
            }
            isShowLoading.value = true;
            try {
                const res = await fetch(`/discount/${discountCode}?redirect=/cart`)
                if (res?.ok) {
                    await getCartJsonData(); // 刷新购物车数据，拿到最新的折扣信息等
                    setTimeout(()=>{
                        if(cartJsonData.value && cartJsonData.value?.discount_codes?.length > 0){
                            // 说明有折扣了，拿到折扣的信息，展示给用户
                            cartJsonData.value?.discount_codes.forEach((item)=>{
                                if (item.code === discountCode){
                                    if (!item.applicable){
                                        message.textContent = "Code not applied. It may be invalid, ineligible, or less valuable than your current discount.";
                                        message.style.color = "red";
                                    }
                                }
                            })
                        }
                    }, 100)
                } else {
                    message.textContent = "Invalid discount code, please try again.";
                    message.style.color = "red";
                }
            } catch (err){
                message.textContent = "Invalid discount code, please try again.";
                message.style.color = "red";
            }finally{
                isShowLoading.value = false;
                // 不管成功失败都清空输入框
                document.getElementById("myCustomCartDiscountCodeInputId").value = '';
                setTimeout(()=>{
                    message.textContent = ''
                },2000)
            }
        };
        const removeInputDiscountFn = (code) => {
            // 目前shopify没有提供接口可以单独移除某个折扣码，所以只能重新提交一次购物车，提交的时候把不需要的折扣码去掉。
            const newDiscounts = inputDiscounts.value.filter(item => item !== code);
            isShowLoading.value = true;
            fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    discount: newDiscounts.join(','),
                })
            }).then(r => r.json()).then(data => {
                if (data?.token) {
                    cartJsonData.value = data;
                    // getCartInitDCFn()
                }
            }).catch(err => {
                console.log(err, 'err');
            }).finally(() => {
                isShowLoading.value = false;
            });
        }

        // 工具函数
        // 将钱的数字 转为千分位并添加货币符号
        const customMoneyFormatFn = (num) => {
            num = Number(num);
            if (typeof num !== 'number' || isNaN(num)) return 0;
            if (!num) return 0;
            // 货币是包含两位小数的
            num= num / 100
            return currentMoneySymbol.value + num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        return {
            // 变量
            currentMoneySymbol,
            isShowCart,
            isShowLoading,
            cartJsonData,
            cartItems,
            installmentImgList,
            prodRecommendItems,
            recomProdAddCartShow,
            recomProdAddCartItem,
            myCustomFQShow,
            // myCustomCartAddNoteShow,
            // myCustomCartAddNote,
            myCartOtherConfig,
            myCartProdRecommdConfig,
            computedFreeTipsDesc,
            myCustomFreeLineSolidComStyle,
            myCustomFreeGiftIsGet,
            prodRecommendItemTransformWidth,
            cartTopTipsObj,
            inputDiscounts,
            // 函数
            myCustomCartCheckoutStart,
            myCustomCartRecomProdAddToCartStart,
            myCustomCartRecomProdAddToCart,
            recomProdAddCartShowFn,
            myCustomCartRecomProdAddCartVariantChange,
            myCustomCartRecomProdAddToCartConfirm,
            myCustomCartAddProdQuantityFn,
            myGetPurchaseLimitTip,
            myCustomCartQuantityInputOnlyNumberFn,
            myCustomCartQuantityInputCommitFn,
            myCustomCartAddProdQuantiyDeleteFn,
            myCustomCartChangeVarinatStatrFn,
            myCustomFQShowFn,
            myCustomCartRecomProdChargeFn,
            // myCustomCartAddNoteShowFn,
            myCustomVerifyCodeCart,
            removeInputDiscountFn,
            // 工具函数
            customMoneyFormatFn,
        }
    }
}).mount('#myCustomCartBundleId')